import MasterShopFaceRegistrationPage from './MasterShopFaceRegistrationPage';

export default MasterShopFaceRegistrationPage;
